var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.usps)?_c('ul',{staticClass:"usp-list"},_vm._l((_vm.usps),function(usp){return _c('li',{key:usp,staticClass:"usp-list__item mb-1"},[_c('icon',{attrs:{"identifier":"check"}}),_vm._v(" "+_vm._s(usp)+"\n  ")],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }